// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"ContactList_primaryButton__GaRNf"};